<!--  -->
<template>
    <div class='search'>
        <div class="search_box">
            <el-tabs class="search_box_1" v-model="activeName">
                <el-tab-pane label="Search results" name="1">
                    <div class="search_box_2" v-if="list.length!=0">
                        <div class="Methodological">
                            <div class="Methodological_1" v-for="(item,index) in list" :key="index"
                                @click="ondel(item)">{{ item.title }} </div>
                        </div>
                    </div>
                    <div v-else style="padding-bottom: 300px;">
                        Doesn't have your search results.
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: 'search',
        data() {
            //这里存放数据
            return {
                keywork: "",
                activeName: '1',
                list: [],
                routeData: null
            }
        },
        watch: {
            // 深度监听$route的变化  
            '$route': {
                handler(newVal, oldVal) {
                    console.log('路由发生变化:', newVal, '旧值:', oldVal);
                },
                deep: true // 设置为true表示深度监听  
            }
        },
        components: {},

        //方法集合
        methods: {
            // 跳转详情页   
            ondel(item) {
                console.log(item)
                this.$router.push('/details/' + item.code)
            },
            artlist() {
                var _this = this;
                _this.$api.artlist({
                    keyword: _this.keywork
                }).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        _this.list = res.data.list

                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
        },
        created() {

        },

        mounted() {
            if (this.$route.params.keywork) {
                this.keywork = this.$route.params.keywork
                this.artlist()
            }
        }
    }
</script>
<style scoped lang="less">
    .is-top {
        width: 100px;
    }

    /deep/ .is-active {
        color: #076CE0;
    }
</style>